// src/features/admin/adminSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// État initial
const initialState = {
  stats: {
    activePackages: 0,
    totalViews: 0,
    conversionRate: 0,
    activeCompanies: 0,
    potentialClients: 0,
    recentActivity: []
  },
  isLoading: false,
  error: null
};

// Action asynchrone pour récupérer les statistiques du tableau de bord
export const fetchDashboardStats = createAsyncThunk(
  'admin/fetchDashboardStats',
  async (_, { rejectWithValue }) => {
    try {
      // Dans une version complète, cette route API existerait
      const response = await api.get('/admin/dashboard-stats');
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Erreur lors de la récupération des statistiques'
      );
    }
  }
);

// Action asynchrone pour récupérer l'activité récente
export const fetchRecentActivity = createAsyncThunk(
  'admin/fetchRecentActivity',
  async (_, { rejectWithValue }) => {
    try {
      // Dans une version complète, cette route API existerait
      const response = await api.get('/admin/recent-activity');
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Erreur lors de la récupération de l\'activité récente'
      );
    }
  }
);

// Slice Redux pour l'administration
const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    resetAdminError: (state) => {
      state.error = null;
    },
    
    // Pour le développement, on peut simuler des données de statistiques
    setMockStats: (state, action) => {
      state.stats = {
        ...state.stats,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // Gestion de fetchDashboardStats
      .addCase(fetchDashboardStats.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.stats = {
          ...state.stats,
          ...action.payload
        };
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      
      // Gestion de fetchRecentActivity
      .addCase(fetchRecentActivity.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRecentActivity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.stats.recentActivity = action.payload;
      })
      .addCase(fetchRecentActivity.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

// Export des actions
export const { resetAdminError, setMockStats } = adminSlice.actions;

// Sélecteurs
export const selectAdminStats = (state) => state.admin.stats;
export const selectAdminLoading = (state) => state.admin.isLoading;
export const selectAdminError = (state) => state.admin.error;

// Export du reducer
export default adminSlice.reducer;